import * as React from "react";
import { Switch, Route } from "react-router-dom";
import SpirometryAnalysisSetList from "./AnalysisSetsList/SpirometryAnalysisSetList";
import { SpirometryAnalysisScreen } from "./SpirometryAnalysisScreen";
import SpirometrySessionListScreen from "./SessionList/SpirometrySessionListScreen";
import { useQueryTable } from "../../misc/components/queryTable/Hooks/UseQueryTable";
import { OverreadStatusIdEnum, QueryCondition, QueryOrderDirection } from "../../misc/api/apiTypes";
import { useCurrentStudyConfigurationContext } from "../../Core/CurrentStudyConfigurationContext";
import { ActiveSpirometrySessionView } from "./Testing/ActiveSpirometrySessionView";
import { ChallengeOverreaderDecisionPanel, ModalVisibilityParams } from "../Shared/ChallengeOverreaderDecisionPanel";

export const SpirometryRoot = () => {
    const { tableParameters } = useCurrentStudyConfigurationContext();

    const analysisSetQueryTableReducer = useQueryTable({
        query: {
            Order: {
                Member: "CreatedDateTime",
                Direction: QueryOrderDirection.Ascending,
            },
            Page: {
                Current: 1,
                Length: tableParameters.DefaultPageSize,
            },
            Filters: [{
                Member: 'StatusId',
                Condition: QueryCondition.Equal,
                Values: [OverreadStatusIdEnum.Pending, OverreadStatusIdEnum.NotStarted]
            }]
        }
    });

    return (
        <Switch>
            <Route path="/Spirometry" exact>
                <SpirometrySessionListScreen />
            </Route>
            <Route path="/Spirometry/Analysis" exact>
                <SpirometryAnalysisSetList queryTableReducer={analysisSetQueryTableReducer} />
            </Route>
            <Route path="/Spirometry/Analysis/:analysisSetId/:viewState" component={SpirometryAnalysisScreen} />
            <Route path="/Spirometry/SiteAnalysis/:analysisSetId/:viewState" component={ActiveSpirometrySessionView} />
            <Route path="/Spirometry/:analysisSetId/ChallengeDecision">
                <SpirometrySessionListScreen />
                <ChallengeOverreaderDecisionPanel/>
            </Route>  
        </Switch>
    );
}
